class NewCtlCreateOwnSet extends HTMLElement {
  constructor() {
    super();

    this.requiredCount = parseInt(this.dataset.requiredCount, 10) || 6;
    this.checkboxes = Array.from(
      this.querySelectorAll('.new-ctl-create-own-set__product input[type="checkbox"]:not(:disabled)')
    );
    this.savedItemsInput = this.querySelector("[data-set-value]");
    this.savedProductItems = Array.from(this.querySelectorAll(".saved_item-select"));
    this.currentCount = this.querySelector("[data-current-count]");
    this.progressLabel = this.querySelector("[data-progress-label]");
    this.progressMeter = this.querySelector("[data-progress-meter]");
    this.progressBar = this.querySelector("[data-progress-bar]");
    this.addBtn = this.querySelector("[data-add-set]");
    this.addLabel = this.querySelector("[data-add-label]");
    this.drawerAddButtons = Array.from(this.querySelectorAll("[data-drawer-add-sample]"));

    this.bindSelectionEvents();
    this.bindDrawerAddEvents();
    this.handleAddSetToCart();
    this.updateSelectionUi();
  }

  bindSelectionEvents() {
    this.checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", () => {
        if (checkbox.checked && this.getCheckedCount() > this.requiredCount) {
          alert(`You can only select ${this.requiredCount} perfumes`);
          checkbox.checked = false;
          return;
        }

        this.syncSavedItems();
        this.updateSelectionUi();
      });
    });
  }

  bindDrawerAddEvents() {
    this.drawerAddButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();

        const checkbox = this.getDrawerButtonCheckbox(button);

        if (!checkbox || checkbox.disabled) {
          return;
        }

        if (!checkbox.checked && this.getCheckedCount() >= this.requiredCount) {
          this.updateSelectionUi();
          return;
        }

        const isAddingSample = !checkbox.checked;

        checkbox.checked = !checkbox.checked;
        checkbox.dispatchEvent(new Event("change", { bubbles: true }));

        if (isAddingSample && checkbox.checked) {
          this.closeDrawerForButton(button);
        }
      });
    });
  }

  getDrawerButtonCheckbox(button) {
    const targetInputId = button?.dataset?.targetInput;
    const checkbox = targetInputId ? document.getElementById(targetInputId) : null;

    if (!checkbox || !this.contains(checkbox)) {
      return null;
    }

    return checkbox;
  }

  closeDrawerForButton(button) {
    const drawer = button.closest("quick-view-drawer");

    if (!drawer) {
      return;
    }

    if (typeof drawer.hide === "function") {
      drawer.hide();
      return;
    }

    drawer.removeAttribute("open");
  }

  getCheckedCount() {
    return this.checkboxes.filter((checkbox) => checkbox.checked).length;
  }

  syncSavedItems() {
    this.savedProductItems.forEach((item) => {
      item.classList.remove("active");
      item.removeAttribute("data-handle");
      item.removeAttribute("data-title");
    });

    this.checkboxes
      .filter((checkbox) => checkbox.checked)
      .forEach((checkbox, index) => {
        const savedItem = this.savedProductItems[index];

        if (!savedItem) {
          return;
        }

        savedItem.classList.add("active");
        savedItem.setAttribute("data-handle", checkbox.value);
        savedItem.setAttribute("data-title", checkbox.dataset.title || "");
      });
  }

  updateSelectionUi() {
    const count = this.getCheckedCount();
    const remaining = Math.max(this.requiredCount - count, 0);
    const progress = Math.min((count / this.requiredCount) * 100, 100);

    if (this.savedItemsInput) {
      this.savedItemsInput.value = count;
    }

    if (this.currentCount) {
      this.currentCount.textContent = count;
    }

    if (this.progressLabel) {
      if (remaining === 0) {
        this.progressLabel.textContent = "All perfumes selected";
      } else {
        this.progressLabel.textContent = `Choose ${remaining} perfume${remaining === 1 ? "" : "s"} to try`;
      }
    }

    if (this.progressMeter) {
      this.progressMeter.setAttribute("aria-valuenow", String(count));
    }

    if (this.progressBar) {
      this.progressBar.style.width = `${progress}%`;
    }

    this.updateCardsUi();
    this.updateDrawerButtonsUi();
    this.updateAddButtonUi(remaining);
  }

  updateCardsUi() {
    const selectionLimitReached = this.getCheckedCount() >= this.requiredCount;

    this.querySelectorAll(".new-ctl-create-own-set__product").forEach((card) => {
      const checkbox = card.querySelector('input[type="checkbox"]');
      const label = card.querySelector("[data-card-action-label]");
      const icon = card.querySelector("[data-card-action-icon]");

      if (!checkbox || checkbox.disabled) {
        card.classList.add("is-unavailable");
        card.classList.remove("is-limit-inactive");
        if (label) {
          label.textContent = "Sold out";
        }
        return;
      }

      card.classList.toggle("is-selected", checkbox.checked);
      card.classList.toggle("is-limit-inactive", selectionLimitReached && !checkbox.checked);

      if (label) {
        label.textContent = checkbox.checked ? "Added" : "Add";
      }

      if (icon) {
        icon.textContent = checkbox.checked ? "" : "+";
      }
    });
  }

  updateDrawerButtonsUi() {
    const selectionLimitReached = this.getCheckedCount() >= this.requiredCount;

    this.drawerAddButtons.forEach((button) => {
      const checkbox = this.getDrawerButtonCheckbox(button);
      const label = button.querySelector("[data-drawer-add-sample-label]");

      if (!checkbox || checkbox.disabled) {
        button.disabled = true;
        button.classList.remove("is-selected", "is-limit-inactive");
        button.setAttribute("aria-disabled", "true");

        if (label) {
          label.textContent = "Sold out";
        }

        return;
      }

      const limitInactive = selectionLimitReached && !checkbox.checked;

      button.disabled = limitInactive;
      button.classList.toggle("is-selected", checkbox.checked);
      button.classList.toggle("is-limit-inactive", limitInactive);
      button.setAttribute("aria-disabled", limitInactive ? "true" : "false");
      button.setAttribute("aria-pressed", checkbox.checked ? "true" : "false");

      if (label) {
        label.textContent = checkbox.checked ? "Added" : "Add Sample";
      }
    });
  }

  updateAddButtonUi(remaining) {
    if (!this.addBtn) {
      return;
    }

    if (remaining === 0) {
      this.addBtn.disabled = false;
      if (this.addLabel) {
        this.addLabel.textContent = "Add to cart";
      }
      return;
    }

    this.addBtn.disabled = true;

    if (!this.addLabel) {
      return;
    }

    if (remaining === this.requiredCount) {
      this.addLabel.textContent = `Select ${this.requiredCount} samples`;
    } else {
      this.addLabel.textContent = `Add ${remaining} more sample${remaining === 1 ? "" : "s"}`;
    }
  }

  normalizeBundleOptionTitle(title) {
    return String(title || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/\b\d+\s*ml\b/g, "")
      .replace(/[^a-z0-9]+/g, "");
  }

  formatBundleOptionValue(title) {
    const baseTitle = String(title || "")
      .trim()
      .replace(/\s*-\s*2\s*ml\s*-\s*2\s*ml\s*$/i, "")
      .replace(/\s+2\s*ml\s*-\s*2\s*ml\s*$/i, "")
      .replace(/\s*-\s*2\s*ml\s*$/i, "")
      .replace(/\s+2\s*ml\s*$/i, "")
      .trim();

    return baseTitle ? `${baseTitle} - 2 ML` : "";
  }

  getSimpleBundlesOptionValues() {
    const optionValues = [];
    const addOptionValue = (value) => {
      const trimmedValue = String(value || "").trim();

      if (trimmedValue && !optionValues.includes(trimmedValue)) {
        optionValues.push(trimmedValue);
      }
    };
    const addOptionValues = (values) => {
      String(values || "")
        .split(",")
        .forEach(addOptionValue);
    };

    document
      .querySelectorAll('#simple-bundles-io-options select option[value]:not([disabled])')
      .forEach((option) => addOptionValue(option.value));

    const bundleVariantId = this.querySelector("#bundle-variation-id")?.value;
    const simpleBundlesVariant = window.SimpleBundles?.productVariants?.[bundleVariantId];

    simpleBundlesVariant?.variant_options?.forEach((option) => {
      addOptionValues(option.optionValues);
    });
    (simpleBundlesVariant?.variant_options_v2?.flat?.(2) || []).forEach((option) => {
      addOptionValues(option.optionValues);
    });

    return optionValues;
  }

  getSimpleBundlesOptionValue(title) {
    const normalizedTitle = this.normalizeBundleOptionTitle(title);
    const fallbackValue = this.formatBundleOptionValue(title);
    const normalizedFallbackValue = this.normalizeBundleOptionTitle(fallbackValue);
    const options = this.getSimpleBundlesOptionValues();

    for (const option of options) {
      const normalizedOptionValue = this.normalizeBundleOptionTitle(option);

      if (
        normalizedOptionValue === normalizedTitle ||
        normalizedOptionValue === normalizedFallbackValue
      ) {
        return option;
      }
    }

    if (options.length > 0) {
      return "";
    }

    return fallbackValue;
  }

  handleAddSetToCart() {
    if (!this.addBtn) {
      return;
    }

    this.addBtn.addEventListener("click", async (event) => {
      event.preventDefault();

      const savedItems = this.querySelectorAll(".saved_item-select.active");
      const checkedItems = this.querySelectorAll(
        '.new-ctl-create-own-set__product input[type="checkbox"]:checked'
      );

      if (savedItems.length !== this.requiredCount || checkedItems.length !== this.requiredCount) {
        alert(`Please select ${this.requiredCount} samples before adding to cart.`);
        return;
      }

      this.addBtn.disabled = true;

      const propertiesData = {};
      const bundleSelectionArray = [];

      savedItems.forEach((item, index) => {
        const title = item.getAttribute("data-title");
        const optionName = (
          item.getAttribute("data-bundle-option-name") || `Product ${index + 1}`
        ).trim();
        const bundleOptionValue = this.getSimpleBundlesOptionValue(title);

        propertiesData[optionName] = bundleOptionValue;
        bundleSelectionArray.push(bundleOptionValue);
      });

      const validBundleSelections = bundleSelectionArray.filter(Boolean);
      if (validBundleSelections.length !== this.requiredCount) {
        alert(`Please select ${this.requiredCount} samples before adding to cart.`);
        this.updateSelectionUi();
        return;
      }

      const bundleVariantId = +this.querySelector("#bundle-variation-id").value;
      const bundleProductId = +this.querySelector("#bundle-product-id").value;

      propertiesData["_bundle_selection"] = bundleSelectionArray.join(" <> ");

      const data = {
        items: [
          {
            quantity: 1,
            id: bundleVariantId,
            properties: propertiesData,
            "product-id": bundleProductId,
          },
        ],
      };

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        });
        const responseData = await response.json();

        if (!response.ok) {
          throw new Error(
            responseData?.description ||
              responseData?.message ||
              "An error occurred while adding the set to your cart."
          );
        }

        document.dispatchEvent(
          new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
              cart: responseData,
              baseEvent: "variant:add",
            },
          })
        );

        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) {
          cartDrawer.show();
        } else {
          console.error("Cart drawer element not found");
        }

        document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      } catch (error) {
        console.error(error);
      } finally {
        this.updateSelectionUi();
      }
    });
  }
}

if (!customElements.get("new-ctl-create-own-set")) {
  customElements.define("new-ctl-create-own-set", NewCtlCreateOwnSet);
}
